export const callAppropriateCb = (cbHandler, response) => {
    if ("updateType" in response) {
        cbHandler[`on${response.updateType}`](response.payload);
    }
    if ("events" in response && "markets" in response) {
        cbHandler.onInitial(response);
    }
};
//# sourceMappingURL=callAppropriateCb.js.map